import './global/animation'
import './global/scroll-to'

import './components/appointment'
import './components/benefits'
import './components/carousel'
import './components/countdown'
import './components/gallery'
import './components/masonry'
import './components/stage'
import './components/leaflet'
import './components/map'
